import { defineMessages } from 'react-intl';

const messages = defineMessages({
  installDescription: {
    id: 'context.pwaInstallPrompt.installDescription',
    defaultMessage:
      'This web app has the same functionalities as the mobile app. Add the Icon to your Home screen and use it the same as any other app - just better!',
  },
  installTitle: {
    id: 'pwaInstallPromptContext.installTitle',
    defaultMessage: 'Add to Home Screen',
  },
  installButton: {
    id: 'context.pwaInstallPrompt.installButton',
    defaultMessage: 'Install',
  },
  close: {
    id: 'context.pwaInstallPrompt.close',
    defaultMessage: 'Close',
  },
  stepAddToHomeScreen: {
    id: 'context.pwaInstallPrompt.stepAddToHomeScreen',
    defaultMessage: "Press 'Add to Home Screen'",
  },
  stepShare: {
    id: 'context.pwaInstallPrompt.stepShare',
    defaultMessage: "Press the 'Share' button on the menu bar",
  },
  // Safari 26's Compact layout (the default) keeps Share behind "•••" beside
  // the address bar; its Bottom and Top layouts show Share directly, and a page
  // cannot tell which one is in use.
  stepMore: {
    id: 'context.pwaInstallPrompt.stepMore',
    defaultMessage:
      "If you don't see 'Share', press '•••' next to the address bar",
  },
  stepShareInMenu: {
    id: 'context.pwaInstallPrompt.stepShareInMenu',
    defaultMessage: "Press 'Share'",
  },
});

export default messages;
